const ContactMethods = () => {
  const methods = [
    {
      icon: 'ri-phone-line',
      title: 'Call Us',
      mainInfo: '01943 123456',
      subInfo: 'Mon-Sat, 9am-6pm',
    },
    {
      icon: 'ri-mail-line',
      title: 'Email Us',
      mainInfo: 'hello@riverdalehair.studio',
      subInfo: 'We reply within 24 hours',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Visit Us',
      mainInfo: 'By appointment',
      subInfo: 'Walk-ins welcome',
    },
  ];

  return (
    <section className="bg-cream py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-3 gap-8">
          {methods.map((method, index) => (
            <div key={index} className="text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-6">
                <i className={`${method.icon} text-5xl text-sage`}></i>
              </div>

              <h3 className="text-xl font-semibold text-charcoal font-sans mb-3">
                {method.title}
              </h3>

              <p className="text-lg text-gray-700 font-sans mb-2">
                {method.mainInfo}
              </p>

              <p className="text-sm text-gray-500 font-sans">
                {method.subInfo}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactMethods;